"use client";

import CurrentJobs from "./Jobs/CurrentJobs";

export const JobsOpening = () => {
  return (
    <section id="jobs">
      <div className="container">
        <div className="row">
          <div className="content">
            <h6 className="color-dark-blue f-w-700 font-barlow">Career Opportunities</h6>
            <br />
            <h6 className="p-35 l-h-1-2 color-black f-w-700 font-barlow">Build Your Career with Universal Surgical Assistants</h6>
            <br />
            <p className="font-nunito-sans p-18 f-w-400 l-h-1-5 ">
              Universal Surgical Assistants (USA) provide essential support to surgeons during procedures, ensuring patient safety and comfort
              throughout. They assist with surgical preparation, intraoperative tasks, and postoperative care, making them indispensable members of
              the surgical team. With their attention to detail and dedication to excellence, they play a crucial role in successful surgical
              outcomes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
export const JobFeature = () => {
  return (
    <section id="jobs">
      <div className="container">
        <div className="row">
          <div className="job-box">
            <CurrentJobs />
          </div>
        </div>
      </div>
    </section>
  );
};
